
export class FAQ {

    public Order: string = '';
    public Question: string = '';
    public Answer: string = '';
}